import React from "react";
import PropTypes from "prop-types";

import SelectableElement from "./SelectableElement";
import SelectableSection from "./SelectableSection";
import ValuePlaceholder from "./ValuePlaceholder";

const FooterSectionViewer = ({ invoiceData }) => {
  const { footerSection } = invoiceData;
  return (
    <SelectableSection
      section="footerSection"
      isSelectable={footerSection.isSelectable}
    >
      <div style={footerSection.style}>
        {footerSection.paragraph.map((paragraph, index) => (
          <SelectableElement
            as="div"
            key={index}
            style={paragraph.style}
            id={`footerSection.paragraph[${index}].text`}
            stylePath={`footerSection.paragraph[${index}].style`}
          >
            {paragraph.text}
            {index === 0 && (
              <ValuePlaceholder placeholderKey="search_code">
                WVXVR6YWL87WY
              </ValuePlaceholder>
            )}
          </SelectableElement>
        ))}
      </div>
    </SelectableSection>
  );
};

FooterSectionViewer.propTypes = {
  invoiceData: PropTypes.object,
};

export default FooterSectionViewer;
